import { RecalProcessAndGenEntity } from "domain/entity/Recalculation/RecalProcessAndGenEntity";
import { EMPTY_RECAL_PROCESS_AND_GEN_GENERATE_CRITERIA, RecalProcessAndGenGenerateCriteria } from "domain/entity/Recalculation/RecalProcessAndGenGenerateCriteria";
import { EMPTY_RECAL_PROCESS_AND_GEN_SEARCH_CRITERIA, RecalProcessAndGenSearchCriteria } from "domain/entity/Recalculation/RecalProcessAndGenSearchCriteria";
import { EMPTY_RECAL_PROCESS_AND_GEN_SUBMIT_ENTITY, RecalProcessAndGenSubmitEntity } from "domain/entity/Recalculation/RecalProcessAndGenSubmitEntity";
import { DropdownProps } from "../DropdownProps";

export interface RecalProcessAndGenDropdownOptions {
    companyCodeDropdownOptions: DropdownProps[],
    oldRecalProposalSetDropdownOptions: DropdownProps[],
    newRecalProposalSetDropdownOptions: DropdownProps[],
    customerCodeDropdownOptions: DropdownProps[],
    chargeTypeDropdownOptions: DropdownProps[],
    subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] },
    tariffTypeDropdownOptions: DropdownProps[],
    tariffCodeDropdownOptions: { [key: string]: DropdownProps[] },
}


export interface RecalProcessAndGenMaintenanceModel {

    isLoading: boolean,
    isShowCriteriaPanel: boolean,
    isShowGeneratePanel: boolean,
    isShowSubmitEditPanel: boolean,
    isShowEditPanel: boolean,
    isAssignSeq: boolean,
    oneOffRate: number | null,
    seqNo: number | null,
    isShowSubmitPanel: boolean,
    isSubmitAll: boolean,
    forceRefresh: boolean,
    recalProcessAndGenList: RecalProcessAndGenEntity[],
    recalProcessAndGenSubmitList: RecalProcessAndGenSubmitEntity[],
    currentSubmitRow: RecalProcessAndGenSubmitEntity,
    currentSubmitEditRow: RecalProcessAndGenSubmitEntity,
    selectRows: RecalProcessAndGenEntity[],
    selectSubmitRows: RecalProcessAndGenSubmitEntity[],
    searchCriteria: RecalProcessAndGenSearchCriteria,
    generateCriteria: RecalProcessAndGenGenerateCriteria,
    dynamicOptions: RecalProcessAndGenDropdownOptions,
    allFormState?: { [x: string]: string },
}

export const EMPTY_RECAL_PROCESS_AND_GEN_MAINTENANCE_MODEL: RecalProcessAndGenMaintenanceModel = {
    isLoading: false,
    isShowCriteriaPanel: false,
    searchCriteria: { ...EMPTY_RECAL_PROCESS_AND_GEN_SEARCH_CRITERIA },
    dynamicOptions: {
        companyCodeDropdownOptions: [],
        customerCodeDropdownOptions: [],
        chargeTypeDropdownOptions: [],
        subChargeTypeDropdownOptions: {},
        tariffTypeDropdownOptions: [],
        tariffCodeDropdownOptions: {},
        oldRecalProposalSetDropdownOptions: [],
        newRecalProposalSetDropdownOptions: []
    },

    allFormState: {},
    recalProcessAndGenList: [],
    selectRows: [],
    isShowGeneratePanel: false,
    generateCriteria: { ...EMPTY_RECAL_PROCESS_AND_GEN_GENERATE_CRITERIA },
    recalProcessAndGenSubmitList: [],
    selectSubmitRows: [],
    isShowSubmitPanel: false,
    forceRefresh: false,
    isShowSubmitEditPanel: false,
    currentSubmitRow: { ...EMPTY_RECAL_PROCESS_AND_GEN_SUBMIT_ENTITY },
    currentSubmitEditRow: { ...EMPTY_RECAL_PROCESS_AND_GEN_SUBMIT_ENTITY },
    isShowEditPanel: false,
    isAssignSeq: false,
    oneOffRate: null,
    seqNo: null,
    isSubmitAll: false
}